import { Controller } from "@hotwired/stimulus";
import { flashQuantity, cancelQuantityFlash } from "../utils/quantity_flash";

// Connects to data-controller="update-quantity"
export default class extends Controller {
  static targets = ["content", "decrement", "increment"];

  connect() {
    this.#renderBounds();
  }

  refresh() {
    this.#renderBounds();
  }

  increment() {
    this.#step(1);
  }

  decrement() {
    this.#step(-1);
  }

  disconnect() {
    if (this.hasContentTarget) cancelQuantityFlash(this.contentTarget);
  }

  #step(delta) {
    const { value, min, max } = this.contentTarget;
    const quantity = parseInt(value) + delta;
    if (min !== "" && quantity < +min) return;
    if (max !== "" && quantity > +max) return;

    this.contentTarget.value = quantity;
    this.#renderBounds();
    this.contentTarget.dispatchEvent(new Event("input", { bubbles: true }));
    flashQuantity(this.contentTarget);
  }

  #renderBounds() {
    const { value, min, max } = this.contentTarget;

    Object.entries({
      decrement: min !== "" && +value <= +min,
      increment: max !== "" && +value >= +max
    }).forEach(([name, disabled]) => {
      this[`${name}Targets`].forEach((button) => {
        button.disabled = disabled;
      });
    });
  }
}
